export default __webpack_public_path__ + "static/media/oscer-weight-loss.f7275000.svg";